import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { authGuard } from './guard/auth.guard';
import { nativeUpdateGuard } from './guard/native-update.guard';
import { permissionGuard } from './guard/permission.guard';

const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    data: { allowExpiredAccess: true },
    loadChildren: () => import('./page/dashboard/dashboard.module').then(m => m.DashboardPageModule)
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    data: { allowExpiredAccess: true },
    loadChildren: () => import('./page/dashboard/dashboard.module').then(m => m.DashboardPageModule)
  },
  {
    path: 'list',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'listas.visualizar' },
    loadChildren: () => import('./lista/list/list.module').then(m => m.ListPageModule)
  },
  {
    path: 'create-lista',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'listas.criar' },
    loadChildren: () => import('./lista/create-lista/create-lista.module').then(m => m.CreateListaPageModule)
  },
  {
    path: 'material-aftcs',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'materiais.visualizar' },
    loadChildren: () => import('./material-aftcs/material-aftcs.module').then(m => m.MaterialAftcsPageModule)
  },
  {
    path: 'view-lista',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'listas.visualizar' },
    loadChildren: () => import('./page/view-lista/view-lista.module').then(m => m.ViewListaPageModule)
  },
  {
    path: 'produto',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'materiais.visualizar' },
    loadChildren: () => import('./page/produto/produto.module').then(m => m.ProdutoPageModule)
  },
  {
    path: 'produto-edit',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'materiais.editar' },
    loadChildren: () => import('./page/produto-edit/produto-edit.module').then(m => m.ProdutoEditPageModule)
  },
  {
    path: 'conta',
    canActivate: [authGuard],
    data: { allowExpiredAccess: true },
    loadChildren: () => import('./page/conta/conta.module').then(m => m.ContaPageModule)
  },
  {
    path: 'armazenamento',
    canActivate: [authGuard, permissionGuard],
    data: { allowExpiredAccess: true, title: 'Armazenamento', permission: 'armazenamento.visualizar' },
    loadChildren: () => import('./page/armazenamento/armazenamento.module').then(m => m.ArmazenamentoPageModule)
  },
  {
    path: 'personalizacao-app',
    canActivate: [authGuard, permissionGuard],
    data: {
      title: 'Personalizar app',
      permission: 'personalizacao.gerenciar',
      minimumPlan: 'obras',
      planFeatureName: 'A personalização do aplicativo'
    },
    loadChildren: () => import('./page/personalizacao-app/personalizacao-app.module').then(m => m.PersonalizacaoAppPageModule)
  },
  {
    path: 'recover',
    loadChildren: () => import('./page/recover/recover.module').then(m => m.RecoverPageModule)
  },
  {
    path: 'material-grupo',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'materiais.visualizar' },
    loadChildren: () => import('./page/material-grupo/material-grupo.module').then(m => m.MaterialGrupoPageModule)
  },
  {
    path: 'ferramenta',
    canActivate: [authGuard],
    loadChildren: () => import('./page/ferramenta/ferramenta.module').then(m => m.FerramentaPageModule)
  },
  {
    path: 'escalimetro',
    canActivate: [authGuard],
    loadChildren: () => import('./page/ferramenta/escalimetro/escalimetro.module').then(m => m.EscalimetroPageModule)
  },
  {
    path: 'produto-page-manual',
    canActivate: [authGuard],
    loadChildren: () => import('./page/produto-page-manual/produto-page-manual.module').then(m => m.ProdutoPageManualPageModule)
  },
  {
    path: 'perfil-juridico',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'personalizacao.gerenciar' },
    loadChildren: () => import('./page/perfil-juridico/perfil-juridico.module').then(m => m.PerfilJuridicoPageModule)
  },
  {
    path: 'colecao-create',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'materiais.criar' },
    loadChildren: () => import('./page/colecao-create/colecao-create.module').then(m => m.ColecaoCreatePageModule)
  },
  {
    path: 'user-material-colecao',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'materiais.visualizar' },
    loadChildren: () => import('./page/user-material-colecao/user-material-colecao.module').then(m => m.UserMaterialColecaoPageModule)
  },
  {
    path: 'user-material-colecao-create',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'materiais.criar' },
    loadChildren: () => import('./page/user-material-colecao-create/user-material-colecao-create.module')
      .then(m => m.UserMaterialColecaoCreatePageModule)
  },
  {
    path: 'user-colecao',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'materiais.visualizar' },
    loadChildren: () => import('./page/user-colecao/user-colecao.module').then(m => m.UserColecaoPageModule)
  },
  {
    path: 'material-colecao',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'materiais.visualizar' },
    loadChildren: () => import('./page/material-colecao/material-colecao.module').then(m => m.MaterialColecaoPageModule)
  },
  {
    path: 'cliente-create',
    canActivate: [authGuard, permissionGuard],
    data: { permissionsAny: ['clientes.criar', 'clientes.editar'] },
    loadChildren: () => import('./page/cliente/create/create.module').then(m => m.CreatePageModule)
  },
  {
    path: 'cliente-read',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'clientes.visualizar' },
    loadChildren: () => import('./page/cliente/read/read.module').then(m => m.ReadPageModule)
  },
  {
    path: 'cliente-detalhe',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'clientes.visualizar' },
    loadChildren: () => import('./page/cliente/detalhe/detalhe.module').then(m => m.DetalhePageModule)
  },
  {
    path: 'calculo-cabo-queda-tensao',
    canActivate: [authGuard],
    loadChildren: () => import('./page/ferramenta/eletrica/calculo-cabo-queda-tensao/calculo-cabo-queda-tensao.module')
      .then(m => m.CalculoCaboQuedaTensaoPageModule)
  },
  {
    path: 'calculo-cabo-motor',
    canActivate: [authGuard],
    loadChildren: () => import('./page/ferramenta/eletrica/calculo-cabo-motor/calculo-cabo-motor.module')
      .then(m => m.CalculoCaboMotorPageModule)
  },
  {
    path: 'orcamento-create',
    canActivate: [authGuard, permissionGuard],
    data: { permissionsAny: ['orcamentos.criar', 'orcamentos.editar'] },
    loadChildren: () => import('./page/orcamento/orcamento-create/orcamento-create.module').then(m => m.OrcamentoCreatePageModule)
  },
  {
    path: 'orcamentos',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'orcamentos.visualizar' },
    loadChildren: () => import('./page/orcamento/orcamentos/orcamentos.module').then(m => m.OrcamentosPageModule)
  },
  {
    path: 'orcamento-atividade',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'orcamentos.editar' },
    loadChildren: () => import('./page/orcamento/orcamento-atividade/orcamento-atividade.module').then(m => m.OrcamentoAtividadePageModule)
  },
  {
    path: 'orcamento-view',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'orcamentos.visualizar' },
    loadChildren: () => import('./page/orcamento/orcamento-view/orcamento-view.module').then(m => m.OrcamentoViewPageModule)
  },
  {
    path: 'orcamento-config',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'orcamentos.editar' },
    loadChildren: () => import('./page/orcamento/orcamento-config/orcamento-config.module').then(m => m.OrcamentoConfigPageModule)
  },
  {
    path: 'create-obra',
    canActivate: [authGuard, permissionGuard],
    data: { permissionsAny: ['obras.criar', 'obras.editar'] },
    loadChildren: () => import('./page/obra/create-obra/create-obra.module').then(m => m.CreateObraPageModule)
  },
  {
    path: 'list-obra',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'obras.visualizar' },
    loadChildren: () => import('./page/obra/list-obra/list-obra.module').then(m => m.ListObraPageModule)
  },
  {
    path: 'equipe',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'equipe.visualizar' },
    loadChildren: () => import('./page/equipe/equipe.module').then(m => m.EquipePageModule)
  },
  {
    path: 'epis',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'equipe.visualizar' },
    loadChildren: () => import('./page/epis/epis.module').then(m => m.EpisPageModule)
  },
  {
    path: 'acessos-permissoes',
    canActivate: [authGuard, permissionGuard],
    data: {
      permission: 'equipe.visualizar',
      minimumPlan: 'obras',
      planFeatureName: 'A gestão de acessos e permissões'
    },
    loadChildren: () => import('./page/acessos-permissoes/acessos-permissoes.module').then(m => m.AcessosPermissoesPageModule)
  },
  {
    path: 'detalhe-obra',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'obras.visualizar', permissionScope: 'obra' },
    loadChildren: () => import('./page/obra/detalhe-obra/detalhe-obra.module').then(m => m.DetalheObraPageModule)
  },
  {
    path: 'diarios-obra',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'obras.visualizar', permissionScope: 'obra' },
    loadChildren: () => import('./page/obra/diarios-obra/diarios-obra.module')
      .then(m => m.DiariosObraPageModule)
  },
  {
    path: 'diario-obra-create',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'obras.visualizar', permissionScope: 'obra' },
    loadChildren: () => import('./page/obra/diario-obra-create/diario-obra-create.module')
      .then(m => m.DiarioObraCreatePageModule)
  },
  {
    path: 'calculadora-custos-detalhe',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'custos.visualizar', permissionScope: 'obra' },
    loadChildren: () => import('./page/obra/calculadora-custos-detalhe/calculadora-custos-detalhe.module')
      .then(m => m.CalculadoraCustosDetalhePageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./page/register/register.module').then(m => m.RegisterPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./page/login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'password-update',
    loadChildren: () => import('./page/password-update/password-update.module').then(m => m.PasswordUpdatePageModule)
  },
  {
    path: 'historico-obra',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'relatorio_fotografico.visualizar', permissionScope: 'obra' },
    loadChildren: () => import('./page/obra/historico-obra/historico-obra.module').then(m => m.HistoricoObraPageModule)
  },
  {
    path: 'relatorios-obra',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'relatorios.visualizar', permissionScope: 'obra' },
    loadChildren: () => import('./page/obra/relatorios-obra/relatorios-obra.module').then(m => m.RelatoriosObraPageModule)
  },
  {
    path: 'cronogramas-obra',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'cronograma.visualizar', permissionScope: 'obra' },
    loadChildren: () => import('./page/obra/cronogramas-obra/cronogramas-obra.module').then(m => m.CronogramasObraPageModule)
  },
  {
    path: 'cronograma-obra',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'cronograma.visualizar', permissionScope: 'obra' },
    loadChildren: () => import('./page/obra/cronograma-obra/cronograma-obra.module').then(m => m.CronogramaObraPageModule)
  },
  {
    path: 'historio-obra',
    canActivate: [authGuard],
    loadChildren: () => import('./page/tutorial/historio-obra/historio-obra.module').then(m => m.HistorioObraPageModule)
  },
  {
    path: 'planos',
    canActivate: [authGuard, permissionGuard],
    data: { allowExpiredAccess: true, permission: 'assinatura.gerenciar' },
    loadChildren: () => import('./page/planos/planos.module').then(m => m.PlanosPageModule)
  },
  {
    path: 'list-obra-historico',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'relatorio_fotografico.visualizar' },
    loadChildren: () => import('./page/obra/list-obra-historico/list-obra-historico.module').then(m => m.ListObraHistoricoPageModule)
  },
  {
    path: 'update',
    canMatch: [nativeUpdateGuard],
    loadChildren: () => import('./page/update/update.module').then(m => m.UpdatePageModule)
  },
  {
    path: 'etiqueta-create',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'etiquetas.criar' },
    loadChildren: () => import('./page/etiqueta/etiqueta-create/etiqueta-create.module').then( m => m.EtiquetaCreatePageModule)
  },
  {
    path: 'etiquetas',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'etiquetas.visualizar' },
    loadChildren: () => import('./page/etiqueta/etiquetas/etiquetas.module').then( m => m.EtiquetasPageModule)
  },
  {
    path: 'etiqueta-modal',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'etiquetas.visualizar' },
    loadChildren: () => import('./page/etiqueta/etiqueta-modal/etiqueta-modal.module').then( m => m.EtiquetaModalPageModule)
  },
  {
    path: 'recibo-list',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'recibos.visualizar' },
    loadChildren: () => import('./page/recibo/recibo-list/recibo-list.module').then( m => m.ReciboListPageModule)
  },
  {
    path: 'financeiro',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'financeiro.visualizar' },
    loadChildren: () => import('./page/financeiro/financeiro-dashboard/financeiro-dashboard.module')
      .then(m => m.FinanceiroDashboardPageModule)
  },
  {
    path: 'financeiro-orcamento',
    canActivate: [authGuard],
    loadChildren: () => import('./page/financeiro/financeiro-orcamento/financeiro-orcamento.module')
      .then(m => m.FinanceiroOrcamentoPageModule)
  },
  {
    path: 'agenda-operacional',
    canActivate: [authGuard, permissionGuard],
    data: { modulo: 'agenda', permission: 'agenda.visualizar' },
    loadChildren: () => import('./page/agenda/agenda-operacional/agenda-operacional.module').then( m => m.AgendaOperacionalPageModule)
  },

  {
    path: 'recibo-create',
    canActivate: [authGuard, permissionGuard],
    data: { permissionsAny: ['recibos.criar', 'recibos.editar'] },
    loadChildren: () => import('./page/recibo/recibo-create/recibo-create.module').then( m => m.ReciboCreatePageModule)
  },
  {
    path: 'recibo-view',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'recibos.visualizar' },
    loadChildren: () => import('./page/recibo/recibo-view/recibo-view.module').then( m => m.ReciboViewPageModule)
  },
  {
    path: 'contratos-servicos',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'contratos.visualizar' },
    loadChildren: () => import('./page/contrato-servico/contrato-list/contrato-list.module').then(m => m.ContratoListPageModule)
  },
  {
    path: 'contrato-servico-form',
    canActivate: [authGuard, permissionGuard],
    data: { permissionsAny: ['contratos.criar', 'contratos.editar'] },
    loadChildren: () => import('./page/contrato-servico/contrato-form/contrato-form.module').then(m => m.ContratoFormPageModule)
  },
  {
    path: 'contrato-servico-detalhe',
    canActivate: [authGuard, permissionGuard],
    data: { permission: 'contratos.visualizar' },
    loadChildren: () => import('./page/contrato-servico/contrato-detalhe/contrato-detalhe.module').then(m => m.ContratoDetalhePageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
